export default "__VITE_ASSET__DF6og5mv__"